var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('section',{staticClass:"mask-loading"},[_c('section'),_c('div',{staticClass:"loader"},[_c('atom-spinner',{attrs:{"animation-duration":1000,"size":60,"color":'#ffffff'}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }